import { memo } from 'react';

import { useJourneyTravellerAction } from 'api/traveller-actions/hooks';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { buildEmailPreviewPropsFromTravellerAction } from './email-preview-modal';
import { PreviewEmailMenuItemView } from './preview-email-menu-item';

const ACTION_TYPE = ACTION_TYPES.send_email;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={node.data?.description}
      >
        <NodeActions node={node} customMenuItems={<PreviewEmailMenuItem actionId={node.id} />} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const PreviewEmailMenuItem = ({ actionId }: { actionId: string }) => {
  const { data: action } = useJourneyTravellerAction<typeof ACTION_TYPE>(actionId);

  return (
    <PreviewEmailMenuItemView
      previewProps={action ? buildEmailPreviewPropsFromTravellerAction(action) : undefined}
    />
  );
};
